import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, Card, Col, DatePicker, Form, InputNumber, Row, Spin } from 'antd';
import axios from 'axios';
import dayjs, { Dayjs } from "dayjs";
import { axiosErrorHandler, showSuccessNotification } from '../../../../../swzutils';
import { DateTimeFormat, PercentFormat } from "../../../components/FormattersTS";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
const contractorDiscountTableColumns = [{
        title: 'Effective From',
        dataIndex: 'effectiveFrom',
        width: "70%",
        render: (text /*, record*/) => (_jsx(DateTimeFormat, { value: text }))
    }, {
        title: 'Discount %',
        dataIndex: 'discountPercent',
        width: "30%",
        render: (text /*, record*/) => (_jsx(PercentFormat, { value: text }))
    }];
const TabContractorDiscounts = ({ tenantId }) => {
    const [form] = Form.useForm();
    const [showSpinner, setShowSpinner] = useState(false);
    const tableRef = React.useRef(null);
    const validateEffectiveFrom = (rule, value) => {
        if (value != null && value.isBefore(dayjs())) {
            return Promise.reject("Effective date and time must be after now");
        }
        return Promise.resolve();
    };
    const validateDiscountPercent = (rule, value) => {
        if (value < 0) {
            return Promise.reject("Discount percentage must be greater than zero");
        }
        return Promise.resolve();
    };
    const save = (formValues) => {
        setShowSpinner(true);
        let saveUri = `/admin/v1/tenants/${tenantId}/contractor-discounts`;
        axios(saveUri, {
            method: "post",
            data: {
                "effectiveFrom": formValues.effectiveFrom.toISOString(),
                "discountPercent": formValues.discountPercent / 100
            }
        }).then((response) => {
            tableRef.current?.addRecord(response.data);
            form.resetFields();
            showSuccessNotification('Contractor Discount Successfully Added');
        })
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    return (_jsx(Spin, { spinning: showSpinner, children: _jsx(Form, { layout: "vertical", form: form, onFinish: save, children: _jsxs(Row, { gutter: 10, className: "no-margin", children: [" ", _jsx(Col, { xs: 24, children: _jsx(Card, { title: "Contractor Discounts", type: "inner", variant: 'borderless', children: _jsx(PaginatedFilterableTable, { tableKey: 'tenantContractorDiscounts', ref: tableRef, dataUri: `/admin/v1/tenants/${tenantId}/contractor-discounts`, columns: contractorDiscountTableColumns, refreshOnSelectedTenantChanged: false }) }) }), _jsx(Col, { xs: 24, children: _jsxs(Card, { title: "Change Discount", type: "inner", variant: 'borderless', children: [_jsx(Form.Item, { name: "effectiveFrom", label: "Effective From", rules: [
                                        { required: true, message: 'Please input a value for the effective from date.' },
                                        { validator: validateEffectiveFrom }
                                    ], children: _jsx(DatePicker, { showTime: true, format: "DD/MM/YYYY HH:mm", placeholder: "Effective From" }) }), _jsx(Form.Item, { name: "discountPercent", label: "Discount %", rules: [
                                        { required: true, message: 'Please enter a discount percentage.' },
                                        { validator: validateDiscountPercent }
                                    ], children: _jsx(InputNumber, { style: { width: '100%' }, min: 0, max: 100 }) }), _jsx(Form.Item, { children: _jsx(Button, { htmlType: "button", onClick: () => form.submit(), type: "default", size: "large", children: "Apply Discount" }) })] }) })] }) }) }));
};
export default TabContractorDiscounts;
